(function initializePrivacyConsent() {
  const storageKey = 'kl-cookie-preferences-v1';
  const acceptedConsent = {
    marketing: true,
    analytics: true,
    preferences: true,
    sale_of_data: true,
  };

  function hasStoredConsent(value) {
    return (
      value != null &&
      typeof value.marketing === 'boolean' &&
      typeof value.analytics === 'boolean' &&
      typeof value.preferences === 'boolean' &&
      typeof value.sale_of_data === 'boolean'
    );
  }

  function readStoredConsent() {
    try {
      const raw = window.localStorage.getItem(storageKey);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      console.debug('kl-privacy-consent-init: could not read stored consent', { error });
      return null;
    }
  }

  function writeStoredConsent() {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(acceptedConsent));
    } catch (error) {
      console.debug('kl-privacy-consent-init: could not write stored consent', { error });
    }
  }

  function sendConsentToShopify() {
    const setTrackingConsent = window.Shopify?.customerPrivacy?.setTrackingConsent;

    if (!setTrackingConsent) return false;

    try {
      setTrackingConsent.call(window.Shopify.customerPrivacy, acceptedConsent, (result) => {
        if (result?.error) {
          console.debug('kl-privacy-consent-init: Shopify consent update error', { result });
        }
      });
      return true;
    } catch (error) {
      console.debug('kl-privacy-consent-init: could not call Shopify consent API', { error });
      return false;
    }
  }

  if (hasStoredConsent(readStoredConsent())) return;

  writeStoredConsent();

  let attempts = 0;
  const maxAttempts = 20;
  const sendWhenReady = () => {
    attempts += 1;
    if (sendConsentToShopify() || attempts >= maxAttempts) return;
    window.setTimeout(sendWhenReady, 250);
  };

  sendWhenReady();
})();